import * as routes from "@/router/routes";
import * as C from "@/utility/Constants";

import { getMultiPrivilegeMask } from "@/utility/UserPrivileges";

import { LicenseModuleEnum } from "@/model/data/License/LicenseModuleEnum";
import { ClientPrivileges } from "@/model/data/authentication/ClientPrivilegesEnum";

export default [
    {
        name: "Service and updates",
        name_i18n: "common.license_module.service_and_updates_management",
        icon: "fa-globe",
        isHomeShortcut: false,
        requiredLicenseModules: [LicenseModuleEnum.ServiceAndUpdatesManagement],
        requiredPrivileges: getMultiPrivilegeMask([
            ClientPrivileges.StatusManagement,
            ClientPrivileges.UpdatesManagement,
            ClientPrivileges.PackagesManagement,
            ClientPrivileges.DownloadLogs,
        ]),
        color: C.MODULE_COLORS.SERVICE_AND_UPDATES,
        children: [
            {
                name: "Device Status",
                name_i18n: "device_status.page_title",
                path: routes.DeviceStatus,
                icon: "fa-globe",
                isHomeShortcut: true,
                requiredLicenseModules: [LicenseModuleEnum.ServiceAndUpdatesManagement],
                requiredPrivileges: ClientPrivileges.StatusManagement,
                color: C.MODULE_COLORS.SERVICE_AND_UPDATES,
            },
            {
                name: "Download Logs",
                name_i18n: "downloadLogs.pageTitle",
                path: routes.DownloadLogs,
                icon: "fa-download",
                isHomeShortcut: true,
                requiredLicenseModules: [LicenseModuleEnum.ServiceAndUpdatesManagement],
                requiredPrivileges: ClientPrivileges.DownloadLogs,
                color: C.MODULE_COLORS.SERVICE_AND_UPDATES,
            },
            {
                name: "Updates management",
                name_i18n: "device_update_status.page_title",
                path: routes.UpdatesManagement,
                icon: "fa-cloud-download-alt",
                isHomeShortcut: true,
                requiredLicenseModules: [LicenseModuleEnum.ServiceAndUpdatesManagement],
                requiredPrivileges: ClientPrivileges.UpdatesManagement,
                color: C.MODULE_COLORS.SERVICE_AND_UPDATES,
            },
            {
                name: "Update packages",
                name_i18n: "updates_packages.page_title",
                path: routes.UpdatePackages,
                icon: "fa-file-download",
                isHomeShortcut: true,
                requiredLicenseModules: [LicenseModuleEnum.ServiceAndUpdatesManagement],
                requiredPrivileges: ClientPrivileges.PackagesManagement,
                color: C.MODULE_COLORS.SERVICE_AND_UPDATES,
            },
            {
                name: "Schedule settings",
                name_i18n: "scheduleConfiguration.pageTitle",
                path: routes.ScheduleConfigurations,
                icon: "fa-clock",
                isHomeShortcut: true,
                requiredLicenseModules: [LicenseModuleEnum.ServiceAndUpdatesManagement],
                requiredPrivileges: getMultiPrivilegeMask([ClientPrivileges.UpdatesManagement, ClientPrivileges.DownloadLogs]),
                color: C.MODULE_COLORS.SERVICE_AND_UPDATES,
            },
        ],
    },
    {
        name: "Remote Link",
        name_i18n: "common.license_module.remote_link",
        icon: "fa-link",
        isHomeShortcut: false,
        requiredLicenseModules: [LicenseModuleEnum.RemoteLink],
        requiredPrivileges: getMultiPrivilegeMask([
            ClientPrivileges.RemoteLinkHttp,
            ClientPrivileges.RemoteLinkCaosDb,
            ClientPrivileges.RemoteLinkSsh,
            ClientPrivileges.RemoteLinkUltraVnc,
            ClientPrivileges.RemoteLinkCService,
            ClientPrivileges.RemoteLinkCustom,
        ]),
        color: C.MODULE_COLORS.REMOTE_LINK,
        children: [
            {
                name: "Remote Link",
                name_i18n: "remoteLink.pageTitle",
                path: routes.RemoteLink,
                icon: "fa-link",
                isHomeShortcut: true,
                requiredLicenseModules: [LicenseModuleEnum.RemoteLink],
                requiredPrivileges: getMultiPrivilegeMask([
                    ClientPrivileges.RemoteLinkHttp,
                    ClientPrivileges.RemoteLinkCaosDb,
                    ClientPrivileges.RemoteLinkSsh,
                    ClientPrivileges.RemoteLinkUltraVnc,
                    ClientPrivileges.RemoteLinkCService,
                    ClientPrivileges.RemoteLinkCustom,
                ]),
                color: C.MODULE_COLORS.REMOTE_LINK,
            },
        ],
    },
    {
        name: "One Time Code",
        name_i18n: "common.license_module.one_time_code",
        icon: "fa-key",
        isHomeShortcut: false,
        requiredLicenseModules: [LicenseModuleEnum.OneTimeCode],
        requiredPrivileges: getMultiPrivilegeMask([ClientPrivileges.SmartLockManagement, ClientPrivileges.SmartLockActivation]),
        color: C.MODULE_COLORS.ONE_TIME_CODE,
        children: [
            {
                name: "Smart lock",
                name_i18n: "smartLock.pageTitle",
                path: routes.SmartLock,
                icon: "fa-unlock-alt",
                isHomeShortcut: true,
                requiredLicenseModules: [LicenseModuleEnum.OneTimeCode],
                requiredPrivileges: getMultiPrivilegeMask([ClientPrivileges.SmartLockManagement, ClientPrivileges.SmartLockActivation]),
                color: C.MODULE_COLORS.ONE_TIME_CODE,
            },
        ],
    },
    {
        name: "Predictive Maintenance",
        name_i18n: "common.license_module.predictive_maintenance",
        icon: "fa-server",
        isHomeShortcut: false,
        requiredLicenseModules: [LicenseModuleEnum.PredictiveMaintenance],
        requiredPrivileges: getMultiPrivilegeMask([ClientPrivileges.ReadPredictiveMaintenance, ClientPrivileges.LogAnalysis, ClientPrivileges.PreventiveMaintenanceStatus]),
        color: C.MODULE_COLORS.PREDICTIVE_MAINTENANCE,
        children: [
            {
                name: "Predictive Maintenance",
                name_i18n: "predictiveMaintenance.pageTitle",
                path: routes.PredictiveMaintenance,
                icon: "fa-stethoscope",
                isHomeShortcut: true,
                requiredLicenseModules: [LicenseModuleEnum.PredictiveMaintenance],
                requiredPrivileges: ClientPrivileges.ReadPredictiveMaintenance,
                color: C.MODULE_COLORS.PREDICTIVE_MAINTENANCE,
            },
            {
                name: "Preventive Maintenance",
                name_i18n: "preventiveMaintenance.pageTitle",
                path: routes.PreventiveMaintenance,
                icon: "fa-wrench",
                isHomeShortcut: true,
                requiredLicenseModules: [LicenseModuleEnum.PredictiveMaintenance],
                requiredPrivileges: ClientPrivileges.PreventiveMaintenanceStatus,
                color: C.MODULE_COLORS.PREDICTIVE_MAINTENANCE,
            },
            {
                name: "Log Analysis",
                name_i18n: "logAnalysis.pageTitle",
                path: routes.LogAnalysis,
                icon: "fa-microscope",
                isHomeShortcut: true,
                requiredLicenseModules: [LicenseModuleEnum.PredictiveMaintenance],
                requiredPrivileges: ClientPrivileges.LogAnalysis,
                color: C.MODULE_COLORS.PREDICTIVE_MAINTENANCE,
            },
        ],
    },

    {
        name: "Cash Flow",
        name_i18n: "common.license_module.cash_flow_management",
        icon: "fa-money-bill-wave",
        isHomeShortcut: false,
        requiredLicenseModules: [LicenseModuleEnum.CashFlowManagement],
        requiredPrivileges: getMultiPrivilegeMask([ClientPrivileges.CashFlowContentMonitoring, ClientPrivileges.CashFlowTransactionsReporting]),
        color: C.MODULE_COLORS.CASH_FLOW,
        children: [
            {
                name: "Device Content",
                name_i18n: "deviceContent.pageTitle",
                path: routes.CashContent,
                icon: "fa-money-bill",
                isHomeShortcut: true,
                requiredLicenseModules: [LicenseModuleEnum.CashFlowManagement],
                requiredPrivileges: ClientPrivileges.CashFlowContentMonitoring,
                color: C.MODULE_COLORS.CASH_FLOW,
            },
            {
                name: "Transactions Report",
                name_i18n: "cash_report.page_title",
                path: routes.CashReport,
                icon: "fa-chart-bar",
                isHomeShortcut: true,
                requiredLicenseModules: [LicenseModuleEnum.CashFlowManagement],
                requiredPrivileges: ClientPrivileges.CashFlowTransactionsReporting,
                color: C.MODULE_COLORS.CASH_FLOW,
            },
            {
                name: "Workload Report",
                name_i18n: "workloadReport.pageTitle",
                path: routes.CashWorkload,
                icon: "fa-chart-line",
                isHomeShortcut: true,
                requiredLicenseModules: [LicenseModuleEnum.CashFlowManagement],
                requiredPrivileges: ClientPrivileges.CashFlowWorkloadReporting,
                color: C.MODULE_COLORS.CASH_FLOW,
            },
            {
                name: "Branch Report",
                name_i18n: "branchReport.pageTitle",
                path: routes.BranchReport,
                icon: "fa-exchange-alt",
                isHomeShortcut: true,
                requiredLicenseModules: [LicenseModuleEnum.CashFlowManagement],
                requiredPrivileges: ClientPrivileges.CashFlowBranchReporting,
                color: C.MODULE_COLORS.CASH_FLOW,
            },
            {
                name: "Users Balance",
                name_i18n: "usersBalance.pageTitle",
                path: routes.UsersBalance,
                icon: "fa-user-check",
                isHomeShortcut: true,
                requiredLicenseModules: [LicenseModuleEnum.CashFlowManagement],
                requiredPrivileges: ClientPrivileges.UsersBalanceReport,
                color: C.MODULE_COLORS.CASH_FLOW,
            },
            {
                name: "Channels Balance",
                name_i18n: "channelsBalance.pageTitle",
                path: routes.ChannelsBalance,
                icon: "fa-project-diagram",
                isHomeShortcut: true,
                requiredLicenseModules: [LicenseModuleEnum.CashFlowManagement],
                requiredPrivileges: ClientPrivileges.ChannelsBalanceReport,
                color: C.MODULE_COLORS.CASH_FLOW,
            },
            {
                name: "Bags Cash Report",
                name_i18n: "bagsCashReport.pageTitle",
                path: routes.BagsCashReport,
                icon: "fa-luggage-cart",
                isHomeShortcut: true,
                requiredLicenseModules: [LicenseModuleEnum.CashFlowManagement],
                requiredPrivileges: ClientPrivileges.GetBagsCashReport,
                color: C.MODULE_COLORS.CASH_FLOW,
            },
        ],
    },
    {
        name: "Security and Configuration",
        name_i18n: "common.license_module.security_management",
        icon: "fa-unlock-alt",
        isHomeShortcut: false,
        requiredLicenseModules: [LicenseModuleEnum.SecurityManagement],
        requiredPrivileges: getMultiPrivilegeMask([
            ClientPrivileges.SecurityManagement,
            ClientPrivileges.RollsConfigurationManagement,
            ClientPrivileges.ReferenceConfigurationManagement,
            ClientPrivileges.CaosUserSyncManagement,
            ClientPrivileges.SecurityScheduleWrite,
            ClientPrivileges.CaosConfigurationManagement,
        ]),
        color: C.MODULE_COLORS.SECURITY_AND_CONFIGURATION,
        children: [
            {
                name: "Device Security Management",
                name_i18n: "security_management.page_title",
                path: routes.SecurityConfig,
                icon: "fa-user-lock",
                isHomeShortcut: true,
                requiredLicenseModules: [LicenseModuleEnum.SecurityManagement],
                requiredPrivileges: ClientPrivileges.SecurityManagement,
                color: C.MODULE_COLORS.SECURITY_AND_CONFIGURATION,
            },
            {
                name: "Stocks Config",
                name_i18n: "stocks_config.page_title",
                path: routes.StocksConfig,
                icon: "fa-toolbox",
                isHomeShortcut: true,
                requiredLicenseModules: [LicenseModuleEnum.SecurityManagement],
                requiredPrivileges: ClientPrivileges.RollsConfigurationManagement,
                color: C.MODULE_COLORS.SECURITY_AND_CONFIGURATION,
            },
            {
                name: "Reference Config",
                name_i18n: "reference_configuration.page_title",
                path: routes.ReferenceConfig,
                icon: "fa-calendar-check",
                isHomeShortcut: true,
                requiredLicenseModules: [LicenseModuleEnum.SecurityManagement],
                requiredPrivileges: ClientPrivileges.ReferenceConfigurationManagement,
                color: C.MODULE_COLORS.SECURITY_AND_CONFIGURATION,
            },
            {
                name: "CaosUserSync",
                name_i18n: "caos_user_sync.page_title",
                path: routes.CaosUserSync,
                icon: "fa-people-arrows",
                isHomeShortcut: true,
                requiredLicenseModules: [LicenseModuleEnum.SecurityManagement],
                requiredPrivileges: ClientPrivileges.CaosUserSyncManagement,
                color: C.MODULE_COLORS.SECURITY_AND_CONFIGURATION,
            },
            {
                name: "Caos Configuration",
                name_i18n: "caosConfig.pageTitle",
                path: routes.CaosConfig,
                icon: "fa-file-code",
                isHomeShortcut: true,
                requiredLicenseModules: [LicenseModuleEnum.SecurityManagement],
                requiredPrivileges: ClientPrivileges.CaosConfigurationManagement,
                color: C.MODULE_COLORS.SECURITY_AND_CONFIGURATION,
            },
            {
                name: "Caos Configuration Template",
                name_i18n: "caosTemplate.pageTitle",
                path: routes.CaosTemplate,
                icon: "fa-layer-group",
                isHomeShortcut: true,
                requiredLicenseModules: [LicenseModuleEnum.SecurityManagement],
                requiredPrivileges: ClientPrivileges.CaosConfigurationManagement,
                color: C.MODULE_COLORS.SECURITY_AND_CONFIGURATION,
            },
            {
                name: "Schedule settings",
                name_i18n: "scheduleConfiguration.pageTitle",
                path: routes.ScheduleConfigurations,
                icon: "fa-clock",
                isHomeShortcut: true,
                requiredLicenseModules: [LicenseModuleEnum.SecurityManagement],
                requiredPrivileges: ClientPrivileges.SecurityScheduleWrite,
                color: C.MODULE_COLORS.SECURITY_AND_CONFIGURATION,
            },
        ],
    },
    {
        name: "Fitness statistics",
        name_i18n: "common.license_module.fitness_statistics",
        icon: "fa-table",
        isHomeShortcut: false,
        requiredLicenseModules: [LicenseModuleEnum.FitnessStatistics],
        requiredPrivileges: ClientPrivileges.FitnessStatisticsManagement,
        color: C.MODULE_COLORS.FITNESS,
        children: [
            {
                name: "StatisticsReport",
                name_i18n: "statisticsReport.pageTitle",
                path: routes.StatisticsReport,
                icon: "fa-table",
                isHomeShortcut: true,
                requiredLicenseModules: [LicenseModuleEnum.FitnessStatistics],
                requiredPrivileges: ClientPrivileges.FitnessStatisticsManagement,
                color: C.MODULE_COLORS.FITNESS,
            },
            {
                name: "EcrCodes",
                name_i18n: "ecrCodes.pageTitle",
                path: routes.EcrCodes,
                icon: "fa-euro-sign",
                isHomeShortcut: true,
                requiredLicenseModules: [LicenseModuleEnum.FitnessStatistics],
                requiredPrivileges: ClientPrivileges.FitnessStatisticsManagement,
                color: C.MODULE_COLORS.FITNESS,
            },
        ],
    },
    {
        name: "Tools",
        name_i18n: "common.tools",
        icon: "fa-tools",
        isHomeShortcut: false,
        requiredLicenseModules: [],
        requiredPrivileges: ClientPrivileges.None,
        color: "gray",
        children: [
            {
                name: "Licenses Management",
                name_i18n: "licensesManagement.pageTitle",
                path: routes.LicensesManagement,
                icon: "fa-cubes",
                isHomeShortcut: true,
                requiredLicenseModules: [],
                requiredPrivileges: ClientPrivileges.DeviceLicenseManagement,
                color: "gray",
            },
            {
                name: "Organizations Management",
                name_i18n: "organizationsManagement.pageTitle",
                path: routes.OrganizationsManagement,
                icon: "fa-sitemap",
                isHomeShortcut: true,
                requiredLicenseModules: [],
                requiredPrivileges: ClientPrivileges.OrganizationsManagement,
                color: "gray",
            },
            {
                name: "Organizations Licenses",
                name_i18n: "organizationsLicenses.pageTitle",
                path: routes.OrganizationsLicenses,
                icon: "fa-file-invoice-dollar",
                isHomeShortcut: true,
                requiredLicenseModules: [],
                requiredPrivileges: ClientPrivileges.SuperAdmin,
                color: "gray",
            },
            {
                name: "Branches Management",
                name_i18n: "branchesManagement.pageTitle",
                path: routes.BranchesManagement,
                icon: "fa-building",
                isHomeShortcut: true,
                requiredLicenseModules: [],
                requiredPrivileges: ClientPrivileges.BranchesManagement,
                color: "gray",
            },
            {
                name: "NetworkMetrics",
                name_i18n: "network_metrics.page_title",
                path: routes.NetworkMetrics,
                icon: "fa-network-wired",
                isHomeShortcut: true,
                requiredLicenseModules: [],
                requiredPrivileges: ClientPrivileges.ReadNetworkMetrics,
                color: "gray",
            },
            {
                name: "UserManagement",
                name_i18n: "user_management.page_title",
                path: routes.UserManagement,
                icon: "fa-users",
                isHomeShortcut: true,
                requiredLicenseModules: [],
                requiredPrivileges: ClientPrivileges.UsersManagement,
                color: "gray",
            },
            {
                name: "UserEvents",
                name_i18n: "user_events.pageTitle",
                path: routes.UserEvents,
                icon: "fa-address-book",
                isHomeShortcut: true,
                requiredLicenseModules: [],
                requiredPrivileges: ClientPrivileges.ReadUserEvents,
                color: "gray",
            },
            {
                name: "PlatformMaintenance",
                name_i18n: "platformMaintenance.pageTitle",
                path: routes.PlatformMaintenance,
                icon: "fa-sliders-h",
                isHomeShortcut: true,
                requiredLicenseModules: [],
                requiredPrivileges: ClientPrivileges.PlatformMaintenance,
                color: "gray",
            },
            {
                name: "On Boarding",
                name_i18n: "onBoarding.pageTitle",
                path: routes.OnBoarding,
                icon: "fa-cloud-upload-alt",
                isHomeShortcut: true,
                requiredLicenseModules: [],
                requiredPrivileges: ClientPrivileges.OnBoarding,
                color: "gray",
            },
            {
                name: "DataFlowManagement",
                name_i18n: "dataFlow.pageTitleManagement",
                path: routes.DataFlowManagement,
                icon: "fa-hdd",
                isHomeShortcut: true,
                requiredLicenseModules: [],
                requiredPrivileges: getMultiPrivilegeMask([ClientPrivileges.DataFlowRemoteMessageManagement, ClientPrivileges.DataFlowServicesManagement]),
                color: "gray",
            },
            {
                name: "Options",
                name_i18n: "options.page_title",
                path: routes.Options,
                icon: "fa-cog",
                isHomeShortcut: true,
                requiredLicenseModules: [],
                requiredPrivileges: ClientPrivileges.OptionsManagement,
                color: "gray",
            },
            {
                name: "Information",
                name_i18n: "information.page_title",
                path: routes.Information,
                icon: "fa-info-circle",
                isHomeShortcut: true,
                requiredLicenseModules: [],
                requiredPrivileges: ClientPrivileges.None,
                color: "gray",
            },
            {
                name: "Debug",
                name_i18n: "debug.page_title",
                path: routes.Debug,
                icon: "fa-bug",
                isHomeShortcut: false,
                requiredLicenseModules: [],
                requiredPrivileges: ClientPrivileges.None,
                color: "gray",
            },
        ],
    },
];
